module.exports = __webpack_public_path__ + "img/003.a6ecb064.jpg";